import { Input } from "antd";
import styled from "styled-components";
import React, { forwardRef, useImperativeHandle, useRef } from "react";

const InputWraper = styled.div`
  height: 52px;
  padding: 1px;
  border-radius: 11px;
  transition: all 0.5s ease;
  background: transparent;
  &.input-sot2{
    padding: 0 !important;
  }
  &.input-booking{
      border-radius: 28px !important;
    }
  &.active {
    background: #000;
    &.input-sot2{
      border: transparent !important;
      background: transparent !important;
      padding: 0 !important;
    }
    .ant-input-status-error {
      border-color: transparent !important;
      background: white !important;
    }
    .input-sot{
      border: transparent !important;
    }
    .input-booking{
      border: transparent !important;
    }
  }
`;
const InputTextAreaWraper = styled.div`
  height: 120px;
  padding: 1px;
  border-radius: 11px;
  transition: all 0.5s ease;
  background: #ffffff;
  &.active {
    background: #000;
    &.no-border{
      background: transparent !important;
    }
  }
  &.input-mint {
    background-color: #f5f5f5 !important;
    &.item-name{
      min-height: 47px !important;
      height: auto !important;
    }
  }
`;

const InputStyle = styled(Input)`
  border: none;
  height: 50px;
  background: #ffffff;
  border-radius: 10px;
  font-size: 16px;
  &:focus {
    box-shadow: none;
  }
  &.ant-input-status-error{
    border: 1px solid #E944444D !important;
  }
  &.input-sot{
    border: 1px solid #0000001A;
    &.ant-input{
      background: #ffffff !important;
    }
    &.pr-right{
      padding-right: 48px;
    }
  }
  &.input-booking{
    border: 1px solid #0000001A;
    border-radius: 28px;
    .ant-input{
      background: #ffffff !important;
    }
  }
  &.input-sot2{
    border: 1px solid #0000001A;
    &.ant-input{
      background: #ffffff !important;
    }
  }
`;
const InputTextAreaStyle = styled(Input.TextArea)`
  border: none;
  min-height: 118px !important;
  height: 118px !important;
  scrollbar-width: none;
  background: #ffffff;
  border-radius: 10px;
  font-size: 16px;
  &:focus {
    box-shadow: none;
  }
  &.input-mint {
    background-color: #f5f5f5;
    &.item-name{
      min-height: 45px !important;
      height: auto !important;
    }
    @media screen and (max-width: 992px) {
      background-color: #fff !important;
      &.description {
        background-color: #f5f5f5 !important;
      }
    }
  }
`;

const InputPasswordStyle = styled(Input.Password)`
  border: none;
  height: 50px;
  background: #ffffff;
  border-radius: 10px;
  font-size: 16px;
  &:focus {
    box-shadow: none;
  }
  &.input-sot{
    border: 1px solid #0000001A;
    .ant-input{
      background: #ffffff !important;
    }
  }
  .ant-input-affix-wrapper {
    &:hover {
      box-shadow: none;
      border: none;
    }
    &--focused {
      box-shadow: none;
    }
  }
  .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled) {
    &:hover {
      box-shadow: none;
      border: none !important;
    }
  }
`;

const FormInput = forwardRef((props, ref) => {
  const inputWraperRef = useRef();
  const inputRef = useRef();

  const handleFocus = (event) => {
    inputWraperRef.current.classList.add("active");
  };

  const handleBlur = (event) => {
    inputWraperRef.current.classList.remove("active");
  };

  useImperativeHandle(ref, () => ({
    focus: (option) => {
      inputRef.current.focus(option);
    },
  }));

  return props?.type !== "textarea" ? (
    <InputWraper ref={inputWraperRef} {...props}>
      {props?.type === "password" ? (
        <InputPasswordStyle className={props?.className}
          onBlur={handleBlur}
          onFocus={handleFocus}
          {...props}
        />
      ) : (
        <InputStyle onBlur={handleBlur} onFocus={handleFocus} {...props} ref={inputRef} />
      )}
    </InputWraper>
  ) : (
    <InputTextAreaWraper ref={inputWraperRef} {...props}>
      <InputTextAreaStyle
        onBlur={handleBlur}
        onFocus={handleFocus}
        {...props}
        ref={inputRef}
      />
    </InputTextAreaWraper>
  );
});

export default FormInput;
